(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aa-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSizeGuide(root) {
      if (!root || root.dataset.szcInit === 'true') return;
      root.dataset.szcInit = 'true';

      var openBtn = root.querySelector('[data-szc-open]');
      var overlay = root.querySelector('[data-szc-overlay]');
      var closeBtn = root.querySelector('[data-szc-close]');

      function openModal() {
        if (!overlay) return;
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        if (!overlay) return;
        overlay.hidden = true;
        document.body.style.overflow = '';
        if (openBtn) openBtn.focus();
      }

      if (openBtn) openBtn.addEventListener('click', openModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      if (overlay) {
        overlay.addEventListener('click', function (event) {
          if (event.target === overlay) closeModal();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay && !overlay.hidden) closeModal();
      });

      root.querySelectorAll('[data-szc-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.aa-szc').forEach(initSizeGuide);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
